import { useCurrentStep } from "inbounds/navigation/useCurrentStep";
import { fulfillmentInboundStepToPath } from "inbounds/navigation/fulfillment/fulfillmentInboundStepToPath";
import { InboundStep } from "inbounds/InboundTypes";

export const useCurrentFulfillmentInboundStep = () => {
  return useCurrentStep<InboundStep>(InboundStep, fulfillmentInboundStepToPath);
};
